import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { easeInOut } from '../utils/curves';
import { largeDurationMs } from '../utils/durations';
import KeyframesMotion from './keyframes-motion';
var directionMotions = {
  proportional: {
    bottom: 'translate3d(0, calc(5% + 4px), 0)',
    left: 'translate3d(calc(-5% - 4px), 0, 0)',
    right: 'translate3d(calc(5% + 4px), 0, 0)',
    top: 'translate3d(0, calc(-5% - 4px), 0)'
  },
  constant: {
    bottom: 'translate3d(0, 4px, 0)',
    left: 'translate3d(-4px, 0, 0)',
    right: 'translate3d(4px, 0, 0)',
    top: 'translate3d(0, -4px, 0)'
  }
};
var invertedDirection = {
  top: 'bottom',
  bottom: 'top',
  left: 'right',
  right: 'left'
};
export var fadeInAnimation = function fadeInAnimation(direction) {
  var distance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'proportional';
  return {
    from: _objectSpread({
      opacity: 0
    }, direction !== undefined && {
      transform: directionMotions[distance][direction]
    }),
    '50%': {
      opacity: 1
    },
    to: {
      transform: direction !== undefined ? 'none' : undefined
    }
  };
};
export var fadeOutAnimation = function fadeOutAnimation(direction) {
  var distance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'proportional';
  return {
    from: {
      opacity: 1,
      transform: direction !== undefined ? 'translate3d(0, 0, 0)' : undefined
    },
    to: _objectSpread({
      opacity: 0
    }, direction !== undefined && {
      transform: directionMotions[distance][direction]
    })
  };
};

/**
 * Props for controlling the behavior of the FadeIn animation
 */

/**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */
var FadeIn = function FadeIn(_ref) {
  var children = _ref.children,
    _ref$duration = _ref.duration,
    duration = _ref$duration === void 0 ? largeDurationMs : _ref$duration,
    entranceDirection = _ref.entranceDirection,
    exitDirection = _ref.exitDirection,
    _ref$distance = _ref.distance,
    distance = _ref$distance === void 0 ? 'proportional' : _ref$distance,
    onFinish = _ref.onFinish,
    isPaused = _ref.isPaused;
  var invertedEntranceDirection = entranceDirection && invertedDirection[entranceDirection];
  return /*#__PURE__*/React.createElement(KeyframesMotion, {
    duration: duration,
    enteringAnimation: fadeInAnimation(entranceDirection, distance),
    exitingAnimation: fadeOutAnimation(exitDirection || invertedEntranceDirection, distance),
    animationTimingFunction: function animationTimingFunction() {
      return easeInOut;
    },
    onFinish: onFinish,
    isPaused: isPaused
  }, children);
};
export default FadeIn;